import { getLevelInfo } from '../lib/xp';

export default function UserStats({ profile, session }) {
  if (!profile || !session) return null;

  const email = session.user.email;
  const initials = email ? email[0].toUpperCase() : '?';
  const { level, label, progressPct, xp } = getLevelInfo(profile.total_xp);

  return (
    <div style={{
      padding: '14px 16px',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
        <div style={{
          width: 32, height: 32, borderRadius: '50%',
          background: 'rgba(0,210,200,0.15)',
          border: '1.5px solid #00D2C8',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 13, fontWeight: 700, color: '#00D2C8', flexShrink: 0,
        }}>{initials}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {email?.split('@')[0]}
          </div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>
            Szint {level} · {label}
          </div>
        </div>
        {profile.streak_days > 0 && (
          <div style={{
            background: 'rgba(239,68,68,0.12)',
            border: '0.5px solid rgba(239,68,68,0.3)',
            borderRadius: 100, padding: '2px 8px',
            fontSize: 11, fontWeight: 600, color: '#f87171',
            flexShrink: 0,
          }}>
            🔥 {profile.streak_days}
          </div>
        )}
      </div>

      <div style={{ marginBottom: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>
          ⚡ {xp} XP
        </span>
        <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.25)' }}>
          Szint {level} → {level + 1}
        </span>
      </div>
      <div style={{ height: 4, background: 'rgba(255,255,255,0.08)', borderRadius: 4, overflow: 'hidden' }}>
        <div style={{
          height: '100%',
          width: `${progressPct}%`,
          background: 'linear-gradient(90deg, #00D2C8, #8C50FF)',
          borderRadius: 4,
          transition: 'width 0.5s ease',
        }} />
      </div>
    </div>
  );
}
